import { categorySchema } from '../schemas/plugin.js';
import { paginatedResponse, paginationQuerySchema } from './_shared.js';
/**
 * `GET /api/categories` — paginated list of active plugin categories. Gate
 * `plugins:view`. Surfaces the emergent taxonomy created by the sync-repo
 * find-or-create path; the canonical paginated shape matches `GET /api/flags`.
 */
export const listCategoriesQuerySchema = paginationQuerySchema;
export const listCategoriesResponseSchema = paginatedResponse(categorySchema);
//# sourceMappingURL=categories.js.map